import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '@blueprintjs/core/lib/cjs/components/button/buttons'
import { ButtonGroup } from '@blueprintjs/core/lib/cjs/components/button/buttonGroup'
import cx from 'classnames'

import { getPagesArray } from 'src/utils/pagination/getPagesArray'

import styles from './pagination.module.scss'

const Pagination = ({ currentPage, totalPages, onPageChange, renderPage }) => {
    const currentPageNumber = Number(currentPage)
    const totalPagesNumber = Number(totalPages)
    const pagesToDisplay = getPagesArray({
        totalPages: totalPagesNumber,
        delta: 3,
        currentPage: currentPageNumber,
    })

    // If there is only one page in total then display only the list.
    if (totalPagesNumber === 1) {
        return renderPage()
    }

    const isFirstPage = currentPageNumber <= 1
    const isLastPage = currentPageNumber >= totalPagesNumber

    return (
        <div>
            {renderPage()}
            <br />
            <ButtonGroup className={styles.buttonGroup}>
                <Button
                    disabled={isFirstPage}
                    className={
                        isFirstPage
                            ? styles.firstPageButton
                            : styles.lastPageButton
                    }
                    onClick={() => {
                        onPageChange(1)
                    }}
                >
                    First
                </Button>
                {pagesToDisplay.map((page) => (
                    <Button
                        key={page}
                        className={cx({
                            [styles.lastPageButton]: currentPageNumber === page,
                            [styles.inactivePage]: currentPageNumber !== page,
                        })}
                        aria-current={
                            currentPageNumber === page ? 'page' : null
                        }
                        onClick={() => {
                            if (currentPageNumber !== page) {
                                onPageChange(page)
                            }
                        }}
                    >
                        {page}
                    </Button>
                ))}
                <Button
                    disabled={isLastPage}
                    className={
                        isLastPage
                            ? styles.firstPageButton
                            : styles.lastPageButton
                    }
                    onClick={() => {
                        onPageChange(totalPagesNumber)
                    }}
                >
                    Last
                </Button>
            </ButtonGroup>
        </div>
    )
}

Pagination.propTypes = {
    currentPage: PropTypes.number.isRequired,
    perPage: PropTypes.number.isRequired,
    totalElements: PropTypes.number.isRequired,
    totalPages: PropTypes.number.isRequired,
    onPageChange: PropTypes.func,
    renderPage: PropTypes.func,
}

Pagination.defaultProps = {
    currentPage: 1,
    perPage: 10,
    totalElements: 0,
    totalPages: 1,
    size: 10,
}

export default Pagination
